<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <section>
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-0">{{"SEARCH" | translate}} {{"AND" | translate}} {{"FILTER" | translate }}</h3>
                    <label [ngClass.sm]="'d-none'" [ngClass.xl]="'d-flex w-fit align-items-center'" [ngClass.md]="'d-flex w-fit align-items-center'" *ngIf="tableLimit">{{"SHOW" | translate}}
                        <select class="form-control ml-075 pr-3" (change)="tableLimit=$any($event.target).value">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                </div>
                <div class="card-body row">
                    <div class="col-md-3 col-sm-12" [ngClass.sm]="'mb-1'">
                        <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate"
                               class="form-control"
                               [(ngModel)]="filter_keyword" (ngModelChange)="filterDocuments()"/>
                    </div>
                    <div class="col-md-3 col-sm-12" [ngClass.sm]="'mb-1'">
                        <select name="category" id="category" [(ngModel)]="filter_category" class="form-control"
                                (ngModelChange)="filterDocuments()">
                            <option value="">{{"FILTER_CATEGORY" | translate}}</option>
                            <option *ngFor="let cat of documents_categories" [value]="cat.name">{{cat.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-3 col-sm-12" [ngClass.sm]="'mb-1'">
                        <select name="category" id="status_signature" [(ngModel)]="filter_status_signature"
                                class="form-control" (ngModelChange)="filterDocuments()">
                            <option value='4'>{{"STATUS_SIGNATURE" | translate}}</option>
                            <option *ngFor="let status of _documentService.documents_statuses_signatures"
                                    [value]="status.value">{{status.label | translate}}</option>
                        </select>
                    </div>
                    <div class="col-md-3  col-sm-12">
                        <select name="category" id="status_acception" [(ngModel)]="filter_status_acception"
                                class="form-control" (ngModelChange)="filterDocuments()">
                            <option value="4">{{"STATUS_ACCEPTION" | translate}}</option>
                            <option *ngFor="let status_acception of _documentService.documents_statuses_acception"
                                    [value]="status_acception.value">{{status_acception.label | translate}}</option>
                        </select>
                    </div>
                </div>
            </div>

            <!--desktop-->
            <div class="card">
                <div class="card-body p-0" *ngIf="_utilService.isDesktop">
                    <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="50"
                                   [scrollbarH]="true" [rowHeight]="70"
                                   [limit]="tableLimit" [footerHeight]="50" [rows]="filtered_documents"
                                   [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
                        <ngx-datatable-column name="{{'DOCUMENT' | translate}}" prop="title" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="d-flex align-items-center">
                                    <img src="/assets/images/icons/{{row.fileType}}.png" width="20" class="mr-05"
                                         alt=""/>
                                    <span class="line-height-1">{{ row.title }}</span>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'CATEGORY' | translate}}" prop="document_data.category" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="line-height-1">{{ row.document_data.category }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'DATE' | translate}}" prop="send_date" [sortable]="true" width="70">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="line-height-1">{{ _utilService.formatDate(row.send_date) }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column class="text-small" name="{{'STATUS_SIGNATURE' | translate}}"
                                              prop="user_data.signed" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-pill badge-light-{{_documentService.document_status_signature_sended[row.document_user_data.status].color}} mr-1"
                                      *ngIf="row.document_user_data.signed == 1 && row.document_data.require_signature == 1">
                                    {{_documentService.document_status_signature_sended[row.document_user_data.status].label | translate}}
                                </span>
                                <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.document_data.end_date) ? 'danger' : 'warning'}} mr-1"
                                      *ngIf="row.document_data.end_date && row.document_user_data.signed == 0 && row.document_data.require_signature == 1">
                                        {{"NOT_SIGNED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(row.document_data.end_date, 'DD/MM/YY')}}
                                </span>
                                <span class="badge badge-pill badge-light-danger mr-1"
                                      *ngIf="!row.document_data.end_date && row.document_user_data.signed == 0 && row.document_data.require_signature == 1">
                                        {{"NOT_SIGNED" | translate}}
                                </span>
                                <span class="badge badge-pill badge-light-secondary mr-1"
                                      *ngIf="row.document_data.require_signature == 0">{{"NOT_REQUIRED_SIGNATURE" | translate}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="{{'STATUS_ACCEPTION' | translate}}" prop="having_read" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <span class="badge badge-pill badge-light-success mr-1"
                                      *ngIf="row.document_user_data.having_read == 1 && row.document_data.require_acception == 1">{{"VIEWED" | translate}}
                                </span>
                                <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning'}} mr-1"
                                      *ngIf="row.document_user_data.having_read == 0 && row.document_data.require_acception == 1 && row.document_data.end_date">
                                        {{"NOT_VIEWED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(row.document_data.end_date, 'DD/MM/YY')}}
                                </span>
                                <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning'}} mr-1"
                                      *ngIf="row.document_user_data.having_read == 0 && row.document_data.require_acception == 1 && !row.document_data.end_date">
                                        {{"NOT_VIEWED" | translate}}
                                </span>
                                <span class="badge badge-pill badge-light-secondary mr-1"
                                      *ngIf="row.document_data.require_acception == 0">{{"NOT_REQUIRED_VIEW" | translate}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="&nbsp;" [sortable]="false">
                            <ng-template ngx-datatable-cell-template let-row="row" class="pl-0">
                                <div class="d-flex align-items-center">
                                    <button class="btn btn-outline-secondary btn-sm"
                                            [routerLink]="'/dashboard/user-document-view/'+row.document_id">{{"VIEW" | translate}}
                                    </button>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>

            <!--mobile - tablet-->
            <div class="card">
                <div class="card-body p-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
                    <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="50"
                                   [scrollbarH]="false" [rowHeight]="250"
                                   [limit]="tableLimit" [rows]="filtered_documents"
                                   [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}">
                        <ngx-datatable-column name="{{'DOCUMENT' | translate}}" prop="title" [sortable]="true">
                            <ng-template ngx-datatable-cell-template let-row="row">
                                <div class="row list-item-mobile">
                                    <div class="col-12 mb-1" [ngClass.md]="'pl-0'">
                                        <div class="d-flex align-items-center">
                                            <img src="/assets/images/icons/{{row.fileType}}.png" width="20"
                                                 class="mr-05"
                                                 alt=""/>
                                            <span class="line-height-1">{{ row.title }}</span>
                                        </div>
                                    </div>
                                    <div class="col-12" [ngClass.md]="'pl-0'">
                                        <span class="line-height-1">{{ row.document_data.category }}</span>
                                    </div>
                                    <div class="col-12 my-1" [ngClass.md]="'pl-0'">
                                        <span class="badge badge-pill badge-light-{{_documentService.document_status_signature_sended[row.document_user_data.status].color}} mr-1"
                                              *ngIf="row.document_user_data.signed == 1 && row.document_data.require_signature == 1">
                                                {{_documentService.document_status_signature_sended[row.document_user_data.status].label | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning'}} mr-1"
                                              *ngIf="row.document_data.end_date && row.document_user_data.signed == 0 && row.document_data.require_signature == 1">
                                                {{"NOT_SIGNED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(row.document_data.end_date, 'DD/MM/YY')}}
                                        </span>
                                        <span class="badge badge-pill badge-light-danger mr-1"
                                              *ngIf="!row.document_data.end_date && row.document_user_data.signed == 0 && row.document_data.require_signature == 1">
                                                {{"NOT_SIGNED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-secondary mr-1"
                                              *ngIf="row.document_data.require_signature == 0">{{"NOT_REQUIRED_SIGNATURE" | translate}}
                                        </span>
                                    </div>
                                    <div class="col-12 mb-1" [ngClass.md]="'pl-0'">
                                        <span class="badge badge-pill badge-light-success mr-1"
                                              *ngIf="row.document_user_data.having_read == 1 && row.document_data.require_acception == 1">
                                            {{"VIEWED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning'}} mr-1"
                                              *ngIf="row.document_user_data.having_read == 0 && row.document_data.require_acception == 1 && row.document_data.end_date">
                                              {{"NOT_VIEWED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(row.document_data.end_date, 'DD/MM/YY')}}
                                        </span>
                                        <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(row.end_date) ? 'danger' : 'warning'}} mr-1"
                                              *ngIf="row.document_user_data.having_read == 0 && row.document_data.require_acception == 1 && !row.document_data.end_date">
                                              {{"NOT_VIEWED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-secondary mr-1"
                                              *ngIf="row.document_data.require_acception == 0">{{"NOT_REQUIRED_VIEW" | translate}}
                                        </span>
                                    </div>
                                    <div class="col-6" [ngClass.md]="'pl-0'">
                                        <span class="line-height-1">{{ _utilService.formatDate(row.send_date) }}</span>
                                    </div>
                                    <div class="d-flex justify-content-end col-6" [ngClass.md]="'pr-2'">
                                        <button class="btn btn-outline-secondary btn-sm"
                                                [routerLink]="'/dashboard/user-document-view/'+row.document_id">{{"VIEW" | translate}}
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </section>
    </div>
</div>